import PropTypes from "prop-types";

import { AllCorrectAnswersGraphic } from "./AllCorrectAnswersGraphic";
import { CorrectAnswersGraphic } from "./CorrectAnswersGraphic";
import { NoCorrectAnswersGraphic } from "./NoCorrectAnswersGraphic";
import {
  numberCorrectCss,
  countCss,
  correctCss,
  pointsCss,
} from "./SummaryItemGraphic.style";

const propTypes = {
  correctAnswerCount: PropTypes.number,
  count: PropTypes.number,
  points: PropTypes.number,
  isPowerWordQuiz: PropTypes.bool,
};
const HIGHEST_POSSIBLE_VOCABULARY_SCORE = 50;

const SvgTextQuiz = ({ correctAnswerCount, count }) => {
  const hasMaxScore = correctAnswerCount === count;

  return (
    <text x="25" y="55">
      <tspan css={numberCorrectCss(hasMaxScore)} x="1.4em" dy=".3em">
        {correctAnswerCount}
      </tspan>
      <tspan css={countCss(hasMaxScore)} x="4.1em">
        /{count}
      </tspan>
      <tspan css={correctCss(hasMaxScore)} x="4.3em" dy="1.2em">
        Correct
      </tspan>
    </text>
  );
};

const SvgTextPowerWordQuiz = ({ points }) => {
  const pointsHasTwoDigits = (points = 0) => String(points).length === 2;
  const isMaxValue = points === HIGHEST_POSSIBLE_VOCABULARY_SCORE;

  const getPointsXPosition = pointsHasTwoDigits(points) ? "1.5em" : "1.73em";

  return (
    <text x="25" y="55">
      <tspan css={pointsCss(isMaxValue)} x={getPointsXPosition} dy=".3em">
        {points}
      </tspan>
      <tspan css={correctCss(isMaxValue)} x="4.7em" dy="1.2em">
        Points
      </tspan>
    </text>
  );
};

const SummaryItemGraphic = ({
  correctAnswerCount,
  count,
  isPowerWordQuiz,
  points,
}) => {
  const correctAnswerText = `${points} ${points === 1 ? "point" : "points"}`;
  const hasNoCorrectAnswers = correctAnswerCount === 0;

  if (hasNoCorrectAnswers) {
    return (
      <NoCorrectAnswersGraphic correctAnswerText={correctAnswerText}>
        {isPowerWordQuiz ? (
          <SvgTextPowerWordQuiz points={count} />
        ) : (
          <SvgTextQuiz correctAnswerCount={correctAnswerCount} count={count} />
        )}
      </NoCorrectAnswersGraphic>
    );
  } else if (
    points === HIGHEST_POSSIBLE_VOCABULARY_SCORE ||
    (!isPowerWordQuiz && correctAnswerCount === count)
  ) {
    return (
      <AllCorrectAnswersGraphic>
        {isPowerWordQuiz ? (
          <SvgTextPowerWordQuiz points={count} />
        ) : (
          <SvgTextQuiz correctAnswerCount={correctAnswerCount} count={count} />
        )}
      </AllCorrectAnswersGraphic>
    );
  } else {
    return (
      <CorrectAnswersGraphic correctAnswerText={correctAnswerText}>
        {isPowerWordQuiz ? (
          <SvgTextPowerWordQuiz points={count} />
        ) : (
          <SvgTextQuiz correctAnswerCount={correctAnswerCount} count={count} />
        )}
      </CorrectAnswersGraphic>
    );
  }
};

SummaryItemGraphic.propTypes = propTypes;
SvgTextQuiz.propTypes = propTypes;
SvgTextPowerWordQuiz.propTypes = propTypes;
export default SummaryItemGraphic;
